export default __webpack_public_path__ + "static/image3-07ff8aaf208b00cbf1ce1bedd5335bbc.png";